import React, { useState } from 'react'
import { appHistory } from '@core/Utils/routing/history'
import { InAppMarketingModal } from '@mobi/component-library/Areas/InAppMarketing/InAppMarketingModal'
import { useActiveMarketingNotification } from './useActiveMarketingNotification'

export const InAppMarketing = () => {
  const [isModalDismissed, setIsModalDismissed] = useState(false)
  const { activeNotification, dismissNotification, recordNotificationInteraction } =
    useActiveMarketingNotification()

  if (!activeNotification) return

  return (
    <InAppMarketingModal
      isOpen={!isModalDismissed}
      onCancel={() => {
        setIsModalDismissed(true)
        // delay to account for animation
        setTimeout(dismissNotification, 300)
      }}
      onButtonClicked={(link: string, buttonIndex: number) => {
        recordNotificationInteraction(buttonIndex)
        appHistory.push(link)
      }}
      notification={{ ...activeNotification }}
    />
  )
}
